import { GetUserProfile } from "api/endpoints";
import { useDispatch } from "react-redux";
import { setUserPermission } from "../../Redux/userSlice";

const { useEffect } = require("react")



function UpdateProfile({ loginId }) {


    const dispatch = useDispatch();


    useEffect(() => {
        GetUserProfile(loginId).then(res => {

            const perms = JSON.parse(res?.data?.data?.permissions)
            console.log(perms, 'permsss')

            dispatch(setUserPermission(perms))

        }).catch(err => {

        });

    }, [loginId])



    return (<></>)

}


export default UpdateProfile;